// Nazwy linii urządzeń na liście (grupy) - z opisu linii w Go (`NAZWY_LINII`, te same w tytułach powiadomień), kolor
// produktu i ikona linii. Każda linia dostaje własny moduł (karta, nastawy) w swoim plastrze.
import { NAZWY_LINII, type Rola, type TypLinii } from "../gen/kontrakt";
import { NAZWY_STEROWNIK650 } from "../gen/linie/sterownik-650";
import { NAZWY_STEROWNIKNOW } from "../gen/linie/sterownik-now";
import { NAZWY_WEDZARNIA2 } from "../gen/linie/wedzarnia-2";
import { t } from "../i18n/t";
import { IkonaKolumna, IkonaTermometr, IkonaUrzadzenia, IkonaWedzarnia, type KomponentIkony } from "../uklad/ikony";
import type { LiniaProduktu } from "../uklad/Okno";

/** Kolor produktu (`data-iot-linia`): wędzenie = pomarańcz, destylacja = turkus (T-4 tylko destylacja). */
const PRODUKT: Partial<Record<TypLinii, LiniaProduktu>> = {
  "wedzarnia-2": "wedzenie", "sterownik-now": "destylacja", "sterownik-650": "destylacja", "termometr-t4": "destylacja",
};

const IKONA: Partial<Record<TypLinii, KomponentIkony>> = {
  "wedzarnia-2": IkonaWedzarnia, "sterownik-now": IkonaKolumna, "sterownik-650": IkonaKolumna, "termometr-t4": IkonaTermometr,
};

export function produktLinii(typ: TypLinii): LiniaProduktu | undefined {
  return PRODUKT[typ];
}

export function ikonaLinii(typ: TypLinii): KomponentIkony {
  return IKONA[typ] ?? IkonaUrzadzenia;
}

export function nazwaLinii(typ: TypLinii): string {
  return t(NAZWY_LINII[typ]);
}

/** Słowniki kodów firmware linii (Type.Names w Go - programy, fazy). */
const KODY: Partial<Record<TypLinii, Readonly<Record<string, string>>>> = {
  "wedzarnia-2": NAZWY_WEDZARNIA2, "sterownik-650": NAZWY_STEROWNIK650, "sterownik-now": NAZWY_STEROWNIKNOW,
};

/** Kod programu / fazy nazwą dla człowieka (WLASNY → „Program własny”, POROWNANIE.md 14); spoza słownika (nazwa
 *  przepisu) - bez zmian. Jedyne miejsce zamiany kodów w APP. */
export function nazwaKodu(typ: TypLinii, kod: string): string {
  const n = KODY[typ]?.[kod.trim().toUpperCase()];
  return n ? t(n) : kod;
}

/** Konto widzi sztukę jak właściciel: alarmy, parametry sprzętu, ustawienia (właściciel 24.10 - serwisant z aktywnej
 *  zgody też). Udostępnianie, nazwa, zgody na dane, zgłoszenie usterki, energia i lokalizacja - tylko właściciel.
 *  Jedyne miejsce tej reguły w APP. */
export function jakWlasciciel(d: { rola: Rola }): boolean {
  return d.rola === "wlasciciel" || d.rola === "serwis";
}

/** Nazwa sztuki: nadana przez klienta, a bez niej linia + SN („Wędzarnia 1234”, „Termometr T-4 5678”) -
 *  właściciel 22.10: zamiast „Urządzenie SN” albo samego numeru. Jedyne miejsce tej reguły w APP. */
export function nazwaSztuki(d: { nazwa?: string | null; typ: TypLinii; sn: string }): string {
  return d.nazwa || nazwaLinii(d.typ) + " " + d.sn;
}
